// noinspection JSUnusedGlobalSymbols

//if changing this - adjust winSequenceManager logic
export const allBets = [0, 10, 25, 100, 500, 2500] as const;
export type Bet = typeof allBets[number];

export enum NFTRankNames {
  NOOB = 'noob',
  KID = 'kid',
  PRO = 'pro',
  LEGEND = 'legend',
  MASTERBATOR = 'masterbator'
}

export interface NFTRank {
  name: NFTRankNames;
  stars: number;
  cardsAmount: number;
}

export const getAvailableBets = (rank: NFTRankNames): Bet[] => {
  switch (rank) {
    case NFTRankNames.NOOB:
      return allBets.slice(0, 2);
    case NFTRankNames.KID:
      return allBets.slice(0, 3);
    case NFTRankNames.PRO:
      return allBets.slice(0, 4);
    case NFTRankNames.LEGEND:
      return allBets.slice(0, 5);
    case NFTRankNames.MASTERBATOR:
      return allBets.slice(0, 6);
    default:
      return allBets.slice(0, 2);
  }
};

export const getRanksForBet = (bet: Bet): NFTRankNames[] => {
  switch (bet) {
    case allBets[0]:
      return [
        NFTRankNames.NOOB,
        NFTRankNames.KID,
        NFTRankNames.PRO,
        NFTRankNames.LEGEND,
        NFTRankNames.MASTERBATOR
      ];
    case allBets[1]:
      return [
        NFTRankNames.NOOB,
        NFTRankNames.KID,
        NFTRankNames.PRO,
        NFTRankNames.LEGEND,
        NFTRankNames.MASTERBATOR
      ];
    case allBets[2]:
      return [
        NFTRankNames.KID,
        NFTRankNames.PRO,
        NFTRankNames.LEGEND,
        NFTRankNames.MASTERBATOR
      ];
    case allBets[3]:
      return [NFTRankNames.PRO, NFTRankNames.LEGEND, NFTRankNames.MASTERBATOR];
    case allBets[4]:
      return [NFTRankNames.LEGEND, NFTRankNames.MASTERBATOR];
    default: {
      return [NFTRankNames.MASTERBATOR];
    }
  }
};

export const getNFTRankNameByLevel = (level: number): NFTRankNames => {
  if (level < 75) return NFTRankNames.NOOB;
  if (level < 250) return NFTRankNames.KID;
  if (level < 500) return NFTRankNames.PRO;
  if (level < 900) return NFTRankNames.LEGEND;
  return NFTRankNames.MASTERBATOR;
};

const buildRank = (
  name: NFTRankNames,
  stars: number,
  cardsAmount: number
): NFTRank => ({ name, stars, cardsAmount });

export const getNFTRank = (name: NFTRankNames, level: number): NFTRank => {
  switch (name) {
    case NFTRankNames.NOOB: {
      if (level < 25) return buildRank(name, 1, 2);
      if (level < 50) return buildRank(name, 2, 2);
      return buildRank(name, 3, 2);
    }
    case NFTRankNames.KID: {
      if (level < 125) return buildRank(name, 1, 3);
      if (level < 175) return buildRank(name, 2, 3);
      return buildRank(name, 3, 3);
    }
    case NFTRankNames.PRO: {
      if (level < 325) return buildRank(name, 1, 4);
      if (level < 400) return buildRank(name, 2, 4);
      return buildRank(name, 3, 4);
    }
    case NFTRankNames.LEGEND: {
      if (level < 600) return buildRank(name, 1, 5);
      if (level < 700) return buildRank(name, 2, 5);
      return buildRank(name, 3, 5);
    }
    default: {
      //MASTERBATOR
      if (level < 1500) return buildRank(name, 1, 5);
      if (level < 3000) return buildRank(name, 2, 5);
      return buildRank(name, 3, 5);
    }
  }
};

type NFTLevels = { low: number; high: number };

export const getNFTLevelsByRankName = (rank: NFTRankNames): NFTLevels => {
  switch (rank) {
    case NFTRankNames.NOOB:
      return { low: 1, high: 74 };
    case NFTRankNames.KID:
      return { low: 75, high: 249 };
    case NFTRankNames.PRO:
      return { low: 250, high: 499 };
    case NFTRankNames.LEGEND:
      return { low: 500, high: 899 };
    default:
      return { low: 900, high: 5000 };
  }
};

export const compareRanks = (
  rank1: NFTRankNames,
  rank2: NFTRankNames
): -1 | 0 | 1 => {
  const level1 = getNFTLevelsByRankName(rank1).low;
  const level2 = getNFTLevelsByRankName(rank2).low;
  if (level1 > level2) return 1;
  if (level1 === level2) return 0;
  return -1;
};
